/**
 * Footer component (RAISEARTH): EU funding logo + disclaimer.
 * Customization of @plone/volto/components/theme/Footer/Footer
 * @module components/theme/Footer/Footer
 */

import React from 'react';
import { Container, Segment } from 'semantic-ui-react';
import euLogo from './footer.png';

const Footer = () => {
  return (
    <Segment
      role="contentinfo"
      vertical
      padded
      inverted
      color="grey"
      textAlign="center"
      id="footer"
      aria-label="Footer"
      tabIndex="-1"
    >
      <Container>
        <img
          src={euLogo}
          alt="Funded by the European Union"
          style={{ display: 'block', margin: '0 auto 1rem', width: '15rem', maxWidth: '100%', height: 'auto' }}
        />
        <Segment basic inverted color="grey" className="discreet">
          The RAISEARTH project is funded by the European Union (GA
          101289233). Views and opinions expressed are however those of the
          author(s) only and do not necessarily reflect those of the European
          Union or the European Research Executive Agency (REA). Neither the
          European Union nor the granting authority can be held responsible for
          them.
        </Segment>
      </Container>
    </Segment>
  );
};

export default Footer;
